<template>
  <div class="about__footer">
    <h1 class="about__footer__heading">
      JAK DOŁĄCZYĆ DO<br />
      <b>PROGRAMU GEBERIT&nbsp;PRO?</b>
    </h1>
    <router-link :to="{ name: 'AuthenticationRegister' }">
      <button class="about__footer__button">Zarejestruj się</button>
    </router-link>
    <section class="about__footer__text">
      <h4>Potrzebujesz wsparcia?</h4>
      <p>
        Skontaktuj się z nami: <a href="tel:739095775">739 095 775</a> lub
        <a href="mailto:biuro@geberitpro.pl">biuro@geberitpro.pl</a>
      </p>
    </section>
  </div>
</template>

<script>
export default {
  name: "Footer",
};
</script>



// WEBPACK FOOTER //
// src/app/about/Footer.vue